export const getColumns = () => {
  return [
    {
      Header: "Product Id",
      Footer: "Product Id",
      accessor: "productId",
      sticky: "left",
    },
    {
      Header: "Template Code",
      Footer: "Template Code",
      accessor: "code",
    },
    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "productName",
    },
    {
      Header: "Generated QR",
      Footer: "Generated QR",
      accessor: "totalqrcodecount",
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "status",
    },
    {
      Header: "Generate QR",
      Footer: "Generate QR",
      accessor: "action",
    },
  ];
};
